import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('currentUser') !== 'admin') {
      navigate('/login');
      return;
    }

    const stored = JSON.parse(localStorage.getItem('hotelBookings')) || [];
    setBookings(stored);
    document.title = "Hotel Atlanta | Bookings";
  }, [navigate]);

  const getBookingID = (b) =>
    `${b.email}_${b.checkin}_${b.checkout}_${b.name}`.replace(/\s+/g, '');

  const getDismissed = () =>
    JSON.parse(localStorage.getItem('admin_dismissed')) || [];

  const handleCancel = (target) => {
    const updated = bookings.map(b =>
      getBookingID(b) === getBookingID(target)
        ? { ...b, status: 'Canceled by Admin' }
        : b
    );
    localStorage.setItem('hotelBookings', JSON.stringify(updated));
    setBookings(updated);
  };

  const handleDismiss = (target) => {
    const id = getBookingID(target);
    const dismissed = getDismissed();
    if (!dismissed.includes(id)) {
      localStorage.setItem('admin_dismissed', JSON.stringify([...dismissed, id]));
      const updatedBookings = bookings.filter(
        b => getBookingID(b) !== id
      );
      setBookings(updatedBookings);
    }
  };

  const visibleBookings = bookings.filter(
    b => !getDismissed().includes(getBookingID(b))
  );

  const pageSize = 3;

  useEffect(() => {
    if (startIndex + pageSize > visibleBookings.length && startIndex !== 0) {
      setStartIndex(Math.max(0, visibleBookings.length - pageSize));
    }
  }, [visibleBookings, startIndex]);

  const paginated = visibleBookings.slice(startIndex, startIndex + pageSize);

  const goNext = () => {
    if (startIndex + pageSize < visibleBookings.length) {
      setStartIndex(prev => prev + 1);
    }
  };

  const goPrev = () => {
    if (startIndex > 0) {
      setStartIndex(prev => prev - 1);
    }
  };

  return (
    <div className="container" style={{ padding: '40px' }}>
      <h1 className="l-heading"><span className="text-primary">All</span> Bookings</h1>

      {paginated.length === 0 ? (
        <p>No bookings found.</p>
      ) : (
        <>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '20px',
              marginTop: '20px'
            }}
          >
            {paginated.map((b, index) => {
              const isCanceled = b.status?.includes('Canceled');
              return (
                <div
                  key={index}
                  style={{
                    border: '1px solid #ccc',
                    padding: '15px',
                    borderRadius: '8px',
                    backgroundColor: isCanceled ? '#ffe6e6' : '#f9f9f9',
                    position: 'relative'
                  }}
                >
                  <p><strong>Name:</strong> {b.name}</p>
                  <p><strong>Email:</strong> {b.email}</p>
                  <p><strong>Check-in:</strong> {b.checkin}</p>
                  <p><strong>Check-out:</strong> {b.checkout}</p>
                  <p><strong>Room:</strong> {b.roomLabel}</p>
                  <p><strong>Payment:</strong> {b.payment}</p>
                  <p><strong>Status:</strong> {b.status || 'Confirmed'}</p>

                  {!isCanceled ? (
                    <button style={btn('#e74c3c')} onClick={() => handleCancel(b)}>Cancel</button>
                  ) : (
                    <button style={btn('#888')} onClick={() => handleDismiss(b)}>Dismiss</button>
                  )}
                </div>
              );
            })}
          </div>

          {/* Navigation with fixed position */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
            <div style={{ width: '120px' }}>
              {startIndex > 0 && (
                <button className="btn" onClick={goPrev}>
                  &laquo; Prev
                </button>
              )}
            </div>
            <div style={{ width: '120px', textAlign: 'right' }}>
              {(startIndex + pageSize) < visibleBookings.length && (
                <button className="btn" onClick={goNext}>
                  Next &raquo;
                </button>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const btn = (color) => {
  return {
    backgroundColor: color,
    color: '#fff',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    marginTop: '10px',
    cursor: 'pointer'
  };
};

export default Bookings;